/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { isIE } from "dc-preview-utils/src/Utils/UserAgentUtils";
import docApi from "api";
import { getFirstURLActionInJSON } from "pdfActionManager";
import { EVENT_NAMES } from "constants/enums";
import { crossBrowserURLParse } from "dc-preview-utils/src/Utils/UrlUtils";

export const isValidHttpUrl = urlString => {
  if (urlString && typeof urlString === "string") {
    if (isIE()) {
      return urlString.startsWith("http:") || urlString.startsWith("https:");
    }
    let url;
    try {
      url = crossBrowserURLParse(urlString);
    } catch (err) {
      return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
  }
  return false;
};

export const getLastPartFromPath = path => {
  if (isValidHttpUrl(path)) {
    const urlParts = crossBrowserURLParse(path, "https://example.com");
    const pathPart = urlParts ? urlParts.pathname : path;
    const getOriginPartRegex = /^.*[\\\/]/;
    return pathPart.replace(getOriginPartRegex, "");
  }
  return "";
};

export function getImageDimensionsFromBlobUrl(imgUrl) {
  return new Promise((resolve, reject) => {
    const tempImage = new window.Image();

    tempImage.onload = () => {
      resolve({ width: tempImage.width, height: tempImage.height });
    };

    tempImage.onerror = () => {
      reject(new Error("Could not load image"));
    };

    tempImage.src = imgUrl;
  });
}

export const getFilePathFromRelativeUrl = (urlString, baseUrl) => {
  let url = crossBrowserURLParse(urlString, baseUrl);
  return url.pathname.substring(1);
};

export const getQualifiedUrlFromRelativeUrl = (urlString, baseUrl) => {
  let url = crossBrowserURLParse(urlString, baseUrl);
  return url.href;
};

export const getHyperlinkUrl = async (x, y, pageIndex) => {
  let url;
  const resp = await docApi.isHyperlinkClicked(x, y, pageIndex);
  if (resp && resp.data && resp.data.actions && resp.data.actions[EVENT_NAMES.MOUSE_UP]) {
    url = getFirstURLActionInJSON(resp.data.actions[EVENT_NAMES.MOUSE_UP]);
  }
  return url;
};

/*
  IMPORTANT: Doesn't encode if the URL is partially encoded.
  Be careful when using in a very security important context.
*/
export const generateRedirectURL = megaVerbId => {
  const { origin, pathname, search, hash } = window.location;
  const queryParams = new URLSearchParams(search);
  queryParams.delete("viewer!megaVerb");
  queryParams.set("viewer!megaVerb", megaVerbId);
  return `${origin}${pathname}?${queryParams.toString()}${hash}`;
};

export const isValidUrl = (url, regStr) => {
  const regexPattern = new RegExp(regStr);
  return regexPattern.test(url);
};
